let handleCommon = {
  methods: {
    close() {
      this.$emit('input', false)
    },
  },
}

export { handleCommon }
